module.exports = __webpack_public_path__ + "static/media/Right_Arrow.d1a51dfd.svg";